import * as t from 'io-ts';

export const organizationMetaCodec = t.type({
  name: t.union([t.null, t.string]),
  organization_size: t.union([t.null, t.keyof({
    micro: null,
    extra_small: null,
    small: null,
    medium: null,
    large: null,
    extra_large: null,
  })]),
});

export const organizationMetaResponseCodec = t.type({
  data: organizationMetaCodec,
});

export const templateCodec = t.type({
  id: t.number,
  title: t.string,
  short_description: t.union([t.null, t.string]),
  created_at: t.union([t.null, t.string]),
  updated_at: t.union([t.null, t.string]),
  retrieved_at: t.string,
});

export const featuredTemplatesResponseCodec = t.type({
  data: t.array(templateCodec),
});
